/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddShipmentInput = {
    clientMutationId?: string | null;
    containerSlug: string;
    profileImageSlug?: string | null;
    shipmentType: string;
    vin?: string | null;
    description: string;
    weight?: number | null;
    parentShipment?: string | null;
    dischargeDate?: string | null;
    shipperReleaseCheck?: boolean | null;
    runs?: boolean | null;
    finalReleaseCheck?: boolean | null;
    atbPosition?: string | null;
    customsType?: string | null;
    customsReference?: string | null;
    vinEngine?: string | null;
    vinFuelType?: string | null;
    vinBodyClass?: string | null;
    vinOrigin?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    ticketSlug?: string | null;
    deliveryLocation?: string | null;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type ExternalShipmentAddMutationVariables = {
    input: infoAddShipmentInput;
};
export type ExternalShipmentAddMutationResponse = {
    readonly infoAddShipment: {
        readonly shipment: {
            readonly slug: string;
        };
    } | null;
};
export type ExternalShipmentAddMutation = {
    readonly response: ExternalShipmentAddMutationResponse;
    readonly variables: ExternalShipmentAddMutationVariables;
};



/*
mutation ExternalShipmentAddMutation(
  $input: infoAddShipmentInput!
) {
  infoAddShipment(input: $input) {
    shipment {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalShipmentAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoAddShipmentPayload",
        "kind": "LinkedField",
        "name": "infoAddShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalShipmentAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoAddShipmentPayload",
        "kind": "LinkedField",
        "name": "infoAddShipment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Shipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c3d6710d2cbd7af0853a08b61a019eb",
    "id": null,
    "metadata": {},
    "name": "ExternalShipmentAddMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalShipmentAddMutation(\n  $input: infoAddShipmentInput!\n) {\n  infoAddShipment(input: $input) {\n    shipment {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '434db7b11fb44429832058346a266606';
export default node;
